import { ModuleHeaderSlot, Switch } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useListSettings } from "../useListSettings"

export function Settings() {
    const { translateText } = useLocalization()
    const {
        isLoading,
        compactView,
        showArticleImages,
        showPurchasePrice,
        handleChangeCompactView,
        handleChangeShowArticleImages,
        handleChangeShowPurchasePrice,
    } = useListSettings()

    return (
        <>
            <ModuleHeaderSlot title={translateText(795)}>
                {/* Article Images */}
                <Switch checked={showArticleImages} onChange={handleChangeShowArticleImages} disabled={isLoading} />
            </ModuleHeaderSlot>

            <ModuleHeaderSlot title={translateText(1132)} hideDivider>
                {/* Purchase Price */}
                <Switch checked={showPurchasePrice} onChange={handleChangeShowPurchasePrice} disabled={isLoading} />
            </ModuleHeaderSlot>

            <ModuleHeaderSlot title={translateText(3009)} hideDivider>
                {/* Compact View */}
                <Switch checked={compactView} onChange={handleChangeCompactView} disabled={isLoading} />
            </ModuleHeaderSlot>
        </>
    )
}
